<template>
  <v-container fluid class="px-15 mx-15">
    <Alertas :notificacaoSocket="alertaSocket" :texto="alerta.texto" :tipo="alerta.tipo"></Alertas>

    <v-form v-model="isValido">
      <v-row align="center">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title>| Placar de Movimentação Mensal por Unidade</v-toolbar-title>
          </v-toolbar>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.filtrosRelatorio.unidadesSelecionadas"
            :items="listaDeUnidades"
            :loading="!listaDeUnidades"
            :readonly="!listaDeUnidades"
            :no-data-text="loadingAutocomplete.noDataTextUnidade"
            :rules="[rules.required]"
            chips
            multiple
            label="Selecionar Unidade(s)"
            autocomplete="off"
            prepend-icon="mdi-file-table"
          >
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeUnidade(data.item)">
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete v-model="formRelatorio.filtrosRelatorio.anoSelecionado" :items="listaDeAnos" label="Ano" autocomplete="off" clearable :rules="[rules.requeridoTipo]"></v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete v-model="formRelatorio.filtrosRelatorio.mesesSelecionados" :items="listaDeMeses" :rules="[maxLength(4), rules.required]" chips multiple clearable label="Meses" autocomplete="off">
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeMes(data.item)">
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.filtrosRelatorio.itensSelecionados"
            :items="listaDeItens"
            :loading="!listaDeItens"
            :readonly="!listaDeItens"
            :no-data-text="loadingAutocomplete.noDataTextProduto"
            chips
            multiple
            label="Lista de Produtos em Estoque"
            autocomplete="off"
            prepend-icon="mdi-file-table"
          >
            <template v-slot:selection="data">
              <v-chip v-bind="data.attrs" :input-value="data.selected" close @click="data.select" @click:close="removeItem(data.item)">
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.filtrosRelatorio.descricaoCpf"
            :items="listaDePaciente"
            :loading="!listaDePaciente"
            :readonly="!listaDePaciente"
            :no-data-text="loadingAutocomplete.noDataTextPaciente"
            :search-input.sync="searchPaciente"
            clearable
            @keydown="buscarPacientes"
            label="Pacientes"
            autocomplete="off"
            prepend-icon="mdi-account-group-outline"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete v-model="formRelatorio.filtrosRelatorio.numeroSetor" :items="listaDeSetores" :loading="!listaDeSetores" :readonly="!listaDeSetores" :no-data-text="loadingAutocomplete.noDataTextSetor" label="Setores" autocomplete="off" clearable prepend-icon="mdi-domain"></v-autocomplete>
        </v-col>

        <v-col cols="12" align="center">
          <v-btn :disabled="btnGerarRelatorio" width="300" color="#3cbc62" class="white--text" @click="gerarRelatorio">
            GERAR RELATÓRIO
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <Loading :open="loading" />

    <FormRelatorio :isTheModalOpen="formRelatorio.isOpen" :modalTitleToolbar="formRelatorio.modalTitleToolbar" v-on:fecharModal="formRelatorioClose" v-on:generate-excel="saveExcel(formRelatorio.dataRelatorio)">
      <v-row class="px-2 pb-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>• Saidas Geral - {{ formRelatorio.dataRelatorio.anoSelecionado }}</v-card-title>

            <v-card-text>
              <v-row class="px-2">
                <v-col cols="12">
                  <v-card elevation="0">
                    <v-row>
                      <v-col v-if="formRelatorio.dataRelatorio.itensAgrupadosPaciente.length > 0" cols="12">
                        <DataTable :tableTitle="`• Total Produtos Dispensados para Pacientes - ${formRelatorio.dataRelatorio.anoSelecionado}`" :hideSearch="true" :tableHeader="headerItensAgrupados" :tableRows="formRelatorio.dataRelatorio.itensAgrupadosPaciente"></DataTable>
                      </v-col>
                      <v-col v-else cols="12">
                        <v-card-text>
                          <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos dispensados para pacientes, pois, não há dados suficientes.</span>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="py-2">
                <v-col cols="12">
                  <v-divider />
                </v-col>
              </v-row>

              <v-row class="px-2">
                <v-col cols="12">
                  <v-card elevation="0">
                    <v-row>
                      <v-col v-if="formRelatorio.dataRelatorio.itensAgrupadosSetor.length > 0" cols="12">
                        <DataTable :tableTitle="`• Total Produtos Dispensados para Setores - ${formRelatorio.dataRelatorio.anoSelecionado}`" :hideSearch="true" :tableHeader="headerItensAgrupados" :tableRows="formRelatorio.dataRelatorio.itensAgrupadosSetor"></DataTable>
                      </v-col>
                      <v-col v-else cols="12">
                        <v-card-text>
                          <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos dispensados para setores, pois, não há dados suficientes.</span>
                        </v-card-text>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="py-2">
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>

      <v-row class="px-2 pb-4">
        <v-col cols="12">
          <v-card>
            <v-card-title>• Saidas por Unidade - {{ formRelatorio.dataRelatorio.anoSelecionado }}</v-card-title>

            <v-row>
              <v-col v-if="formRelatorio.dataRelatorio.saidasPorUnidade.length > 0" cols="12">
                <v-list>
                  <v-list-group v-for="(unidadeSelecionada, j) in formRelatorio.dataRelatorio.saidasPorUnidade" :key="j" no-action sub-group>
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title>
                          <div>
                            Unidade: <b>{{ unidadeSelecionada.unidade.nomeEndereco }}</b>
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item>
                      <v-list-item-content class="px-2">
                        <v-row class="px-2">
                          <v-col cols="12">
                            <v-card elevation="0">
                              <v-row>
                                <v-col v-if="unidadeSelecionada.itensAgrupadosPaciente.length > 0" cols="12">
                                  <DataTable :tableTitle="`• Produtos Dispensados para Pacientes`" :hideSearch="true" :tableHeader="headerItensAgrupados" :tableRows="unidadeSelecionada.itensAgrupadosPaciente"></DataTable>
                                </v-col>
                                <v-col v-else cols="12">
                                  <v-card-text>
                                    <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos dispensados para pacientes, pois, não há dados suficientes.</span>
                                  </v-card-text>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>

                        <v-row class="py-2">
                          <v-col cols="12">
                            <v-divider />
                          </v-col>
                        </v-row>

                        <v-row class="px-2">
                          <v-col cols="12">
                            <v-card elevation="0">
                              <v-row>
                                <v-col v-if="unidadeSelecionada.itensAgrupadosSetor.length > 0" cols="12">
                                  <DataTable :tableTitle="`• Produtos Dispensados para Setores`" :hideSearch="true" :tableHeader="headerItensAgrupados" :tableRows="unidadeSelecionada.itensAgrupadosSetor"></DataTable>
                                </v-col>
                                <v-col v-else cols="12">
                                  <v-card-text>
                                    <span class="text-subtitle-1 font-weight-light">Não é possível de exibir a tabela dos produtos dispensados para setores, pois, não há dados suficientes.</span>
                                  </v-card-text>
                                </v-col>
                              </v-row>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-group>
                </v-list>
              </v-col>

              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de exibir os dados de entradas, pois, não há dados para exibir.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </FormRelatorio>
  </v-container>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import FormRelatorio from "../components/FormRelatorio";
import DataTable from "@/components/DataTable2.vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import Blob from "blob";
import Alertas from "../components/Alertas.vue";
import Loading from "../components/Loading.vue";
import validation from "@/utils/validation";

export default {
  components: {
    FormRelatorio,
    DataTable,
    Loading,
    Alertas,
  },

  data: () => ({
    ...validation,

    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    btnGerarRelatorio: false,
    isValido: true,
    loading: false,
    temSubestoque: false,

    page: 1,
    searchPaciente: null,

    loadingAutocomplete: {
      noDataTextUnidade: "Carregando a lista de unidades...",
      noDataTextProduto: "Carregando a lista de produtos...",
      noDataTextPaciente: "Carregando a lista de pacientes...",
      noDataTextSetor: "Carregando lista de setores...",
    },

    //formRelatorio
    formRelatorio: {
      isOpen: false,
      modalTitleToolbar: "Placar de Movimentação Mensal por Unidade",
      filtrosRelatorio: {
        descricaoCpf: null,
        numeroSetor: null,
        anoSelecionado: null,
        unidadesSelecionadas: [],
        itensSelecionados: [],
        mesesSelecionados: [],
      },
      dataRelatorio: {
        anoSelecionado: null,
        mesesSelecionados: [],
        itensAgrupadosPaciente: [],
        itensAgrupadosSetor: [],
        saidasPorUnidade: [],
      },
    },

    //#region HEADERS
    headerItensAgrupados: [
      {
        text: "Nome do Produto",
        value: "nomeItem",
      },
    ],
    //#endregion

    listaDeUnidades: [],
    listaDeItens: [],
    listaDePaciente: [],
    listaDeSetores: [],
    listaDeAnos: [],
    listaDeMeses: [
      { value: 1, text: "JANEIRO" },
      { value: 2, text: "FEVEREIRO" },
      { value: 3, text: "MARÇO" },
      { value: 4, text: "ABRIL" },
      { value: 5, text: "MAIO" },
      { value: 6, text: "JUNHO" },
      { value: 7, text: "JULHO" },
      { value: 8, text: "AGOSTO" },
      { value: 9, text: "SETEMBRO" },
      { value: 10, text: "OUTUBRO" },
      { value: 11, text: "NOVEMBRO" },
      { value: 12, text: "DEZEMBRO" },
    ],

    rules: {
      required: (value) => value.length > 0 || "Requer o campo!",
      requeridoTipo: (value) => value != null || "Requer o campo!",
    },
  }),

  created() {
    this.gerarListaDeAnos();
    this.initialize();
  },

  watch: {
    isValido() {
      this.btnGerarRelatorio = !this.isValido;
    },
    searchPaciente() {
      if (!this.searchPaciente) {
        this.listaPaciente();
      }
    },
  },

  methods: {
    //#region Initialize e Listagens
    async initialize() {
      try {
        this.listaUnidades();
        this.listaItens();
        this.listaPaciente();
        this.listaSetores();
      } catch (error) {
        console.log(error);
      }
    },

    async listaUnidades() {
      try {
        const responseEnderecos = await axios.get("enderecoordemservico", this.config);

        if (responseEnderecos.data.length == 0) {
          this.loadingAutocomplete.noDataTextUnidade = "Não há unidades cadastrados";
        }

        this.listaDeUnidades = responseEnderecos.data.map((row) => {
          return {
            value: row.numeroEnderecoOrdemServico,
            text: row.nomeEndereco,
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaItens() {
      try {
        const responseItens = await axios.put("itemSistemaUnidade", { numeroEndereco: store.state.numeroEndereco }, this.config);

        if (responseItens.data.length == 0) {
          this.loadingAutocomplete.noDataTextProduto = "Não há produtos cadastrados";
        }

        this.listaDeItens = responseItens.data.map((row) => {
          return {
            value: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: row.itemSistema.nomeItemSistema,
            numeroItemSistema: row.itemSistema.numeroItemSistema,
            numeroItemSistemaUnidade: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            quantidadeEstoque: row.quantidadeEstoqueTotal,
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaPaciente() {
      try {
        let responsePaciente = await axios.put("listarPacientePagination", { page: this.page, search: this.searchPaciente }, this.config);

        if (responsePaciente.data.length == 0) {
          this.loadingAutocomplete.noDataTextPaciente = "Não há pacientes cadastrados";
        }

        this.listaDePaciente = responsePaciente.data.map((pacienteSelecionado) => {
          if (pacienteSelecionado.descricaoCpf) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF: " + pacienteSelecionado.descricaoCpf,
            };
          } else if (!pacienteSelecionado.descricaoCpf && pacienteSelecionado.descricaoRG) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  RG: " + pacienteSelecionado.descricaoRG,
            };
          } else if (!pacienteSelecionado.descricaoCpf && !pacienteSelecionado.descricaoRG && pacienteSelecionado.descricaoCpfResponsavel) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF do Responsável: " + pacienteSelecionado.descricaoCpfResponsavel,
            };
          } else {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  Não há dados informados!",
            };
          }
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaSetores() {
      try {
        let responseSetor = await axios.put("setorUnidade", { numeroEndereco: store.state.numeroEndereco }, this.config);

        if (responseSetor.data.length == 0) {
          this.loadingAutocomplete.noDataTextSetor = "Não há setor cadastrado";
        }

        this.listaDeSetores = responseSetor.data.map((row) => {
          return {
            value: row.numeroSetor,
            text: row.nomeSetor,
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    gerarListaDeAnos() {
      const anoAtual = new Date().getFullYear();
      for (let i = 2021; i <= anoAtual; i++) {
        this.listaDeAnos.push({
          value: i,
          text: i,
        });
      }
    },
    //#endregion

    async gerarRelatorio() {
      this.alerta.tipo = "";
      this.loading = true;
      try {
        if (this.formRelatorio.filtrosRelatorio.anoSelecionado) {
          const responseRelatorio = await axios.put("relatorioSaidaMensalAdm", this.formRelatorio.filtrosRelatorio, this.config);

          this.formRelatorio.filtrosRelatorio.mesesSelecionados.map((mesSelecionado) => {
            this.headerItensAgrupados.push(this.adicionarHeader(mesSelecionado));
          });
          this.headerItensAgrupados.push({ text: "Total", value: "total" });

          this.formRelatorio.dataRelatorio.anoSelecionado = this.formRelatorio.filtrosRelatorio.anoSelecionado;
          this.formRelatorio.dataRelatorio.mesesSelecionados = this.formRelatorio.filtrosRelatorio.mesesSelecionados;
          this.formRelatorio.dataRelatorio.itensAgrupadosPaciente = responseRelatorio.data.itensAgrupadosPacienteUnidade;
          this.formRelatorio.dataRelatorio.itensAgrupadosSetor = responseRelatorio.data.itensAgrupadosSetorUnidade;
          this.formRelatorio.dataRelatorio.saidasPorUnidade = responseRelatorio.data.saidasPorUnidade;
        } else {
          this.alerta.texto = "Por favor selecione o ano antes de continuar!";
          this.alerta.tipo = "erro";
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.loading = false;
        this.formRelatorio.isOpen = true;
      }
    },

    formRelatorioClose() {
      this.formRelatorio.dataRelatorio.anoSelecionado = null;
      this.formRelatorio.dataRelatorio.itensAgrupadosPaciente = [];
      this.formRelatorio.dataRelatorio.itensAgrupadosSetor = [];

      (this.headerItensAgrupados = [
        {
          text: "Nome do Produto",
          value: "nomeItem",
        },
      ]),
        (this.formRelatorio.isOpen = false);
    },

    removeUnidade(item) {
      const index = this.formRelatorio.filtrosRelatorio.unidadesSelecionadas.indexOf(item.value);
      if (index >= 0) this.formRelatorio.filtrosRelatorio.unidadesSelecionadas.splice(index, 1);
    },

    removeItem(item) {
      const index = this.formRelatorio.filtrosRelatorio.itensSelecionados.indexOf(item.value);
      if (index >= 0) this.formRelatorio.filtrosRelatorio.itensSelecionados.splice(index, 1);
    },

    removeMes(item) {
      const index = this.formRelatorio.filtrosRelatorio.mesesSelecionados.indexOf(item.value);
      if (index >= 0) this.formRelatorio.filtrosRelatorio.mesesSelecionados.splice(index, 1);
    },

    async buscarPacientes() {
      await this.listaPaciente();
    },

    //#region FORMATERS
    formatDate1(dateDe) {
      if (!dateDe) return null;

      const [day, month, year] = dateDe.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate1(dateDe) {
      if (!dateDe) return null;
      const [day, month, year] = dateDe.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return "Sem Data";
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    formataFamilia(indicador) {
      switch (indicador) {
        case null:
          return "Não vinculado";
        case 0:
          return "Não vinculado";
        case 1:
          return "Medicações";
        case 2:
          return "Materiais";
        case 3:
          return "Psicotrópicos";
        case 4:
          return "Saneantes";
        case 5:
          return "Cosméticos";
        case 6:
          return "Nutrição";
        case 7:
          return "Antimicrobianos";
        case 8:
          return "Amostra Grátis";
        case 9:
          return "Maleta de Emergência";
        case 10:
          return "Doação";
        case 11:
          return "Teste Rápido";
        case 12: 
          return "USO INTERNO";

      }
    },

    formataTipoDispensa(tipo) {
      switch (tipo) {
        case 0:
          return "Comum";
        case 1:
          return "UTI";
        case 2:
          return "Enfermaria";
        case 3:
          return "Centro Cirúrgico";
      }
    },

    adicionarHeader(mesSelecionado) {
      switch (mesSelecionado) {
        case 1:
          return { text: "Janeiro", value: "totalJaneiro" };
        case 2:
          return { text: "Fevereiro", value: "totalFevereiro" };
        case 3:
          return { text: "Março", value: "totalMarco" };
        case 4:
          return { text: "Abril", value: "totalAbril" };
        case 5:
          return { text: "Maio", value: "totalMaio" };
        case 6:
          return { text: "Junho", value: "totalJunho" };
        case 7:
          return { text: "Julho", value: "totalJulho" };
        case 8:
          return { text: "Agosto", value: "totalAgosto" };
        case 9:
          return { text: "Setembro", value: "totalSetembro" };
        case 10:
          return { text: "Outubro", value: "totalOutubro" };
        case 11:
          return { text: "Novembro", value: "totalNovembro" };
        case 12:
          return { text: "Dezembro", value: "totalDezembro" };
      }
    },

    adicionarValorExcel(mesSelecionado, dados) {
      switch (mesSelecionado) {
        case "totalJaneiro":
          return dados.totalJaneiro;
        case "totalFevereiro":
          return dados.totalFevereiro;
        case "totalMarco":
          return dados.totalMarco;
        case "totalAbril":
          return dados.totalAbril;
        case "totalMaio":
          return dados.totalMaio;
        case "totalJunho":
          return dados.totalJunho;
        case "totalJulho":
          return dados.totalJulho;
        case "totalAgosto":
          return dados.totalAgosto;
        case "totalSetembro":
          return dados.totalSetembro;
        case "totalOutubro":
          return dados.totalOutubro;
        case "totalNovembro":
          return dados.totalNovembro;
        case "totalDezembro":
          return dados.totalDezembro;
      }
    },

    formataLetraExcel(tipo) {
      switch (tipo) {
        case 1:
          return "B";
        case 2:
          return "C";
        case 3:
          return "D";
        case 4:
          return "E";
        case 5:
          return "F";
        case 6:
          return "G";
        case 7:
          return "H";
        case 8:
          return "I";
        case 9:
          return "J";
        case 10:
          return "K";
        case 11:
          return "L";
        case 12:
          return "M";
        case 13:
          return "N";
      }
    },
    //#endregion

    //#region Excel
    saveExcel(conteudo) {
      try {
        const workbook = new Workbook();

        var borderStyles = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        //#region GERAL
        var worksheetGeral = workbook.addWorksheet("Saída Total", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheetGeral.columns = [
          { key: "col1", width: 60 },
          { key: "col2", width: 30 },
          { key: "col3", width: 30 },
          { key: "col4", width: 30 },
          { key: "col5", width: 30 },
          { key: "col6", width: 30 },
          { key: "col7", width: 30 },
          { key: "col8", width: 30 },
          { key: "col9", width: 30 },
          { key: "col10", width: 30 },
          { key: "col11", width: 30 },
          { key: "col12", width: 30 },
          { key: "col13", width: 30 },
          { key: "col14", width: 30 },
        ];

        let posicaoLinhaGeral = 1;
        worksheetGeral.mergeCells("A" + posicaoLinhaGeral + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaGeral);
        worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Saidas Geral";
        worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 14, bold: true };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).height = 40;
        posicaoLinhaGeral++;

        //#region DISPENSA PACIENTE
        worksheetGeral.mergeCells("A" + posicaoLinhaGeral + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaGeral);
        worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Produtos Dispensados para Pacientes - " + conteudo.anoSelecionado;
        worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 14, bold: true };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
        posicaoLinhaGeral++;

        if (conteudo.itensAgrupadosPaciente.length > 0) {
          worksheetGeral.getRow(posicaoLinhaGeral).height = 20;
          worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Nome do Produto";
          worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 12, bold: true };
          worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };

          conteudo.mesesSelecionados.map((mesSelecionado, index) => {
            const textoHeader = this.adicionarHeader(mesSelecionado);

            worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).value = textoHeader.text;
            worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 12, bold: true };
            worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
          });

          worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).value = "Total";
          worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 12, bold: true };
          worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
          posicaoLinhaGeral++;

          conteudo.itensAgrupadosPaciente.map((dispensaSelecionada) => {
            worksheetGeral.getCell("A" + posicaoLinhaGeral).value = dispensaSelecionada.nomeItem;
            worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13 };
            worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "left" };

            conteudo.mesesSelecionados.map((mesSelecionado, index) => {
              const textoHeader = this.adicionarHeader(mesSelecionado);

              worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).value = this.adicionarValorExcel(textoHeader.value, dispensaSelecionada);
              worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13 };
              worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "left" };
            });

            worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).value = dispensaSelecionada.total;
            worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13 };
            worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "left" };

            posicaoLinhaGeral++;
          });
          posicaoLinhaGeral++;
        } else {
          worksheetGeral.mergeCells("A" + posicaoLinhaGeral + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaGeral);
          worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Não é possível de exibir a tabela dos produtos dispensados para pacientes, pois, não há dados suficientes.";
          worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13, bold: false };
          worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
          posicaoLinhaGeral++;
        }
        //#endregion

        posicaoLinhaGeral++;
        posicaoLinhaGeral++;
        posicaoLinhaGeral++;

        //#region DISPENSA SETOR
        worksheetGeral.mergeCells("A" + posicaoLinhaGeral + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaGeral);
        worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Produtos Dispensados para Setores - " + conteudo.anoSelecionado;
        worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 14, bold: true };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
        worksheetGeral.getCell("A" + posicaoLinhaGeral).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
        posicaoLinhaGeral++;

        if (conteudo.itensAgrupadosSetor.length > 0) {
          worksheetGeral.getRow(posicaoLinhaGeral).height = 20;
          worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Nome do Produto";
          worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 12, bold: true };
          worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };

          conteudo.mesesSelecionados.map((mesSelecionado, index) => {
            const textoHeader = this.adicionarHeader(mesSelecionado);

            worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).value = textoHeader.text;
            worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 12, bold: true };
            worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
          });

          worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).value = "Total";
          worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 12, bold: true };
          worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
          posicaoLinhaGeral++;

          conteudo.itensAgrupadosSetor.map((dispensaSelecionada) => {
            worksheetGeral.getCell("A" + posicaoLinhaGeral).value = dispensaSelecionada.nomeItem;
            worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13 };
            worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "left" };

            conteudo.mesesSelecionados.map((mesSelecionado, index) => {
              const textoHeader = this.adicionarHeader(mesSelecionado);

              worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).value = this.adicionarValorExcel(textoHeader.value, dispensaSelecionada);
              worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13 };
              worksheetGeral.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "left" };
            });

            worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).value = dispensaSelecionada.total;
            worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13 };
            worksheetGeral.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "left" };

            posicaoLinhaGeral++;
          });
          posicaoLinhaGeral++;
        } else {
          worksheetGeral.mergeCells("A" + posicaoLinhaGeral + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaGeral);
          worksheetGeral.getCell("A" + posicaoLinhaGeral).value = "Não é possível de exibir a tabela dos produtos dispensados para setores, pois, não há dados suficientes.";
          worksheetGeral.getCell("A" + posicaoLinhaGeral).font = { name: "Arial", family: 2, size: 13, bold: false };
          worksheetGeral.getCell("A" + posicaoLinhaGeral).alignment = { vertical: "middle", horizontal: "center" };
          posicaoLinhaGeral++;
        }
        //#endregion

        worksheetGeral.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });
        //#endregion

        //#region POR UNIDADE
        conteudo.saidasPorUnidade.map((unidadeSelecionada) => {
          var worksheetUnidade = workbook.addWorksheet(unidadeSelecionada.unidade.nomeEndereco, {
            properties: { tabColor: { argb: "FF00FF00" } },
            views: [{ showGridLines: false }],
          });

          worksheetUnidade.columns = [
            { key: "col1", width: 60 },
            { key: "col2", width: 30 },
            { key: "col3", width: 30 },
            { key: "col4", width: 30 },
            { key: "col5", width: 30 },
            { key: "col6", width: 30 },
            { key: "col7", width: 30 },
            { key: "col8", width: 30 },
            { key: "col9", width: 30 },
            { key: "col10", width: 30 },
            { key: "col11", width: 30 },
            { key: "col12", width: 30 },
            { key: "col13", width: 30 },
            { key: "col14", width: 30 },
          ];

          let posicaoLinhaUnidade = 1;
          worksheetUnidade.mergeCells("A" + posicaoLinhaUnidade + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaUnidade);
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Saidas da Unidade - " + unidadeSelecionada.unidade.nomeEndereco;
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 14, bold: true };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).height = 40;
          posicaoLinhaUnidade++;

          //#region DISPENSA PACIENTE
          worksheetUnidade.mergeCells("A" + posicaoLinhaUnidade + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaUnidade);
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Produtos Dispensados para Pacientes - " + conteudo.anoSelecionado;
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 14, bold: true };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
          posicaoLinhaUnidade++;

          if (unidadeSelecionada.itensAgrupadosPaciente.length > 0) {
            worksheetUnidade.getRow(posicaoLinhaUnidade).height = 20;
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Nome do Produto";
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 12, bold: true };
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };

            conteudo.mesesSelecionados.map((mesSelecionado, index) => {
              const textoHeader = this.adicionarHeader(mesSelecionado);

              worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).value = textoHeader.text;
              worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 12, bold: true };
              worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
            });

            worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).value = "Total";
            worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 12, bold: true };
            worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
            posicaoLinhaUnidade++;

            unidadeSelecionada.itensAgrupadosPaciente.map((dispensaSelecionada) => {
              worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = dispensaSelecionada.nomeItem;
              worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13 };
              worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "left" };

              conteudo.mesesSelecionados.map((mesSelecionado, index) => {
                const textoHeader = this.adicionarHeader(mesSelecionado);

                worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).value = this.adicionarValorExcel(textoHeader.value, dispensaSelecionada);
                worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13 };
                worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "left" };
              });

              worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).value = dispensaSelecionada.total;
              worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13 };
              worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "left" };

              posicaoLinhaUnidade++;
            });
            posicaoLinhaUnidade++;
          } else {
            worksheetUnidade.mergeCells("A" + posicaoLinhaUnidade + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaUnidade);
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Não é possível de exibir a tabela dos produtos dispensados para pacientes, pois, não há dados suficientes.";
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13, bold: false };
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
            posicaoLinhaUnidade++;
          }
          //#endregion

          posicaoLinhaUnidade++;
          posicaoLinhaUnidade++;
          posicaoLinhaUnidade++;

          //#region DISPENSA SETOR
          worksheetUnidade.mergeCells("A" + posicaoLinhaUnidade + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaUnidade);
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Produtos Dispensados para Setores - " + conteudo.anoSelecionado;
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 14, bold: true };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
          worksheetUnidade.getCell("A" + posicaoLinhaUnidade).fill = { type: "pattern", pattern: "solid", fgColor: { argb: "66cc99" } };
          posicaoLinhaUnidade++;

          if (unidadeSelecionada.itensAgrupadosSetor.length > 0) {
            worksheetUnidade.getRow(posicaoLinhaUnidade).height = 20;
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Nome do Produto";
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 12, bold: true };
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };

            conteudo.mesesSelecionados.map((mesSelecionado, index) => {
              const textoHeader = this.adicionarHeader(mesSelecionado);

              worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).value = textoHeader.text;
              worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 12, bold: true };
              worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
            });

            worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).value = "Total";
            worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 12, bold: true };
            worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
            posicaoLinhaUnidade++;

            unidadeSelecionada.itensAgrupadosSetor.map((dispensaSelecionada) => {
              worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = dispensaSelecionada.nomeItem;
              worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13 };
              worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "left" };

              conteudo.mesesSelecionados.map((mesSelecionado, index) => {
                const textoHeader = this.adicionarHeader(mesSelecionado);

                worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).value = this.adicionarValorExcel(textoHeader.value, dispensaSelecionada);
                worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13 };
                worksheetUnidade.getCell(`${this.formataLetraExcel(index + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "left" };
              });

              worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).value = dispensaSelecionada.total;
              worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13 };
              worksheetUnidade.getCell(`${this.formataLetraExcel(conteudo.mesesSelecionados.length + 1)}` + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "left" };

              posicaoLinhaUnidade++;
            });
            posicaoLinhaUnidade++;
          } else {
            worksheetUnidade.mergeCells("A" + posicaoLinhaUnidade + ":" + this.formataLetraExcel(conteudo.mesesSelecionados.length + 1) + "" + posicaoLinhaUnidade);
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).value = "Não é possível de exibir a tabela dos produtos dispensados para setores, pois, não há dados suficientes.";
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).font = { name: "Arial", family: 2, size: 13, bold: false };
            worksheetUnidade.getCell("A" + posicaoLinhaUnidade).alignment = { vertical: "middle", horizontal: "center" };
            posicaoLinhaUnidade++;
          }
          //#endregion

          worksheetUnidade.eachRow({ includeEmpty: true }, function(row) {
            row.eachCell({ includeEmpty: true }, function(cell) {
              cell.border = borderStyles;
            });
          });
        });
        //#endregion

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Placar de Movimentação Mensal/Anual.xlsx");
        });

        this.rowPosition = 0;
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion
  },
};
</script>
